import React from 'react'
import { useNetworkStatus } from 'shared'

export const OfflineMessage = () => {
  const networkStatus = useNetworkStatus()

  return networkStatus === 'offline' ? (
    <div className="generic-value negative py-3">{i18n.t('errors.messages.offline')}</div>
  ) : null
}
